export default __webpack_public_path__ + "static/media/About_IMG-Accoutability.340b77b5.png";